import { getOrgCustomDomain } from "../config/customDomainMappings";
import { getCleanCustomDomainOrgSlugPath } from "./canonicalPublicRoutes";

// Only production platform hosts: previews and local development stay isolated.
const PLATFORM_HOSTS = new Set(["lightly.web.app", "church-fundraising-rccg.web.app", "church-fundraising-rccg.firebaseapp.com", "lightly.firebaseapp.com"]);
export function getCanonicalProtectedUrl({ orgSlug, hostname, pathname = "/", search = "", hash = "" }) {
  if (!PLATFORM_HOSTS.has(hostname)) return "";
  const domain = getOrgCustomDomain(orgSlug);
  if (!domain) return "";
  // Never accept an external URL or a path belonging to another organization.
  const prefixes = [`/platform/o/${orgSlug}`, `/admin/${orgSlug}`];
  const admin = prefixes.some((prefix) => pathname === prefix || pathname.startsWith(prefix + "/"));
  const clean = getCleanCustomDomainOrgSlugPath({ orgSlug, pathname, search, hash });
  if (!admin && !clean) return "";
  return `https://${domain}${admin ? pathname + search + hash : clean}`;
}
